import { render, staticRenderFns } from "./PersonGroupList.vue?vue&type=template&id=cf0b2a42&"
import script from "./PersonGroupList.vue?vue&type=script&lang=js&"
export * from "./PersonGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports